module.exports = __webpack_public_path__ + "static/media/img.113e6d22.jpg";